// Dashboard Owner

export const GET_SUPPLIES_LISTING_REQUEST = 'GET_SUPPLIES_LISTING_REQUEST';
export const GET_SUPPLIES_LISTING_SUCCESS = 'GET_SUPPLIES_LISTING_SUCCESS';
export const GET_SUPPLIES_LISTING_FAIL = 'GET_SUPPLIES_LISTING_FAIL';

// Export Supplies

export const EXPORT_SUPPLIES_REQUEST = 'EXPORT_SUPPLIES_REQUEST';
export const EXPORT_SUPPLIES_SUCCESS = 'EXPORT_SUPPLIES_SUCCESS';
export const EXPORT_SUPPLIES_FAIL = 'EXPORT_SUPPLIES_FAIL';
export const CLEAR_EXPORT_SUPPLIES_STATE = 'CLEAR_EXPORT_SUPPLIES_STATE';

export const CLEAR_IMPORT_SUPPLIES_STATE = 'CLEAR_IMPORT_SUPPLIES_STATE';
